// extracted by mini-css-extract-plugin
export default {"cls1":"lR0Dz6NOu7TXWlRgOuYc","cls2":"fBggjdbg3MsmP9juZPyR lR0Dz6NOu7TXWlRgOuYc","isPhone":"x2lIVo795Eks7aHBCbqo"};